import { memo } from 'react';
import { Box, ButtonBase, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AddIcon, CloseIcon, DocIcon, FileIcon, PhotoIcon } from '../../../../../components/Icon';
import ImageUploadPreview from '../../../../../components/ImageUploadPreview';
import { isImageFile } from '../../../../../utils';

const useStyles = makeStyles((theme) => ({
  titleText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
  },
  icon: {
    fontSize: '1.25rem',
    color: theme.palette.primary.main,
  },
  fileBox: {
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    minHeight: '3.5rem',
    fontFamily: 'NotoSans-Regular',
    fontSize: '1rem',
    color: '#c0c6cb',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 16.563rem)',
    gridRowGap: '1rem',
    gridColumnGap: '1rem',
  },
  card: {
    width: '16.563rem',
    height: '3.125rem',
    borderRadius: '8px',
    backgroundColor: '#f5faff',
  },
  cardName: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '10rem',
  },
  fileIcon: {
    fontSize: '1.25rem',
    color: theme.palette.primary.main,
  },
  closeIcon: {
    fontSize: '1rem',
    color: theme.palette.primary.main,
  },
  inputfile: {
    width: '0.1px',
    height: '0.1px',
    opacity: 0,
    overflow: 'hidden',
    position: 'absolute',
    zIndex: -1,
  },
  label: {
    display: 'flex',
    cursor: 'pointer',
  },
}));

const FileCard = ({ name, handleDelete, id, ...rest }) => {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      p="0 0.937rem 0 0.813rem"
      justifyContent="space-between"
      alignItems="center"
      className={classes.card}
      {...rest}
    >
      <Box display="flex" alignItems="center">
        <Box display="flex" alignItems="center" justifyContent="center" width="1.5rem" height="1.5rem" mr="0.813rem">
          <DocIcon className={classes.fileIcon} />
        </Box>
        <Typography className={classes.cardName} title={name}>
          {name}
        </Typography>
      </Box>
      <ButtonBase onClick={handleDelete} id={id}>
        <CloseIcon className={classes.closeIcon} />
      </ButtonBase>
    </Box>
  );
};

function UpLoadCom({
  title,
  addTitle,
  setData,
  data,
  handleDeleteFile,
  type,
  accept,
  capture,
  handleSelectFile,
  placeholder,
  id,
  ...rest
}) {
  const classes = useStyles();

  return (
    <Box {...rest}>
      <input
        type="file"
        name={type}
        id={type}
        accept={accept}
        capture={capture}
        onChange={handleSelectFile}
        multiple
        className={classes.inputfile}
        onClick={(event) => {
          event.target.value = '';
        }}
      />
      <Box display="flex" justifyContent="space-between" mb="0.688rem">
        <Box display="flex">
          <Box display="flex" justifyContent="center" alignItems="center" width="1.5rem" height="1.5rem" mr="0.625rem">
            {type === 'photo' ? <PhotoIcon className={classes.icon} /> : <FileIcon className={classes.icon} />}
          </Box>
          <Typography className={classes.titleText} style={{ color: '#001d63' }}>
            {title}
          </Typography>
        </Box>
        <label htmlFor={type} className={classes.label} id={id}>
          <Box display="flex" justifyContent="center" alignItems="center" width="1.5rem" height="1.5rem" mr="0.625rem">
            <AddIcon className={classes.icon} />
          </Box>
          <Typography className={classes.titleText} style={{ color: '#538fff' }}>
            {addTitle}
          </Typography>
        </label>
      </Box>
      <Box p="0.875rem 1.25rem" display="flex" alignItems="center" className={classes.fileBox}>
        {data.length === 0
          ? placeholder
          : data.map((item, index) =>
              isImageFile(item?.name) && item?.previewUrl ? (
                <ImageUploadPreview
                  key={item.id}
                  name={item?.name}
                  previewUrl={item?.previewUrl}
                  handleRemove={handleDeleteFile(item.id, setData)}
                  isEHandover={false}
                />
              ) : (
                <FileCard
                  name={item.name}
                  key={item.id}
                  handleDelete={handleDeleteFile(item.id, setData)}
                  id={`Notification-FileCard-zzy-${index}`}
                />
              )
            )}
      </Box>
    </Box>
  );
}

export default memo(UpLoadCom);
